import { PO_ACTIVITY_ACTION, type PoActivityEvent, type ShipmentLinePayload } from '@/types/poActivity';
import { fmtDate, fmtDay, linesLabel, moveReasonText } from '@/utils/poTracker';

const LOCALE = 'en-US';
const DATE_SEPARATOR = ' · ';
const IMPORTED_SUFFIX = ' · imported';

const pcs = (n: number): string => n.toLocaleString(LOCALE);
const importedSuffix = (imported: boolean | undefined): string => (imported ? IMPORTED_SUFFIX : '');
const linePieces = (lines: ShipmentLinePayload[]): number => lines.reduce((sum, line) => sum + line.quantity, 0);

// Split from poTrackerEvents so poActivity can describe tracker events without an import cycle.
// Returns null for a board action.
export function trackerSentence(e: PoActivityEvent): string | null {
  const p = e.payload;
  switch (p.action) {
    case PO_ACTIVITY_ACTION.SHIPMENT_PLANNED:
      return `Planned ${pcs(linePieces(p.lines))} pcs (${linesLabel(p.lines.length)}) for ${fmtDay(p.plannedDate)}${importedSuffix(p.imported)}`;
    case PO_ACTIVITY_ACTION.SHIPMENT_MOVED:
      return `Moved ${fmtDate(p.from)} → ${fmtDate(p.to)} · ${moveReasonText(p.reason, p.reasonText)}`;
    case PO_ACTIVITY_ACTION.SHIPMENT_LINES_CHANGED:
      return `Changed lines on the ${fmtDate(p.plannedDate)} shipment`;
    case PO_ACTIVITY_ACTION.SHIPMENT_NOTE_CHANGED:
      return `Changed the note on the ${fmtDate(p.plannedDate)} shipment`;
    case PO_ACTIVITY_ACTION.SHIPMENT_REMOVED:
      return `Removed the ${fmtDate(p.plannedDate)} shipment`;
    case PO_ACTIVITY_ACTION.SHIPPED:
      return `Shipped ${pcs(p.pieces)} pcs on ${fmtDate(p.shippedOn)} · ${p.forwarder}${p.hawb ? ` · HAWB/BOL ${p.hawb}` : ''}${importedSuffix(p.imported)}`;
    case PO_ACTIVITY_ACTION.HAWB_ADDED:
      return `Added HAWB/BOL ${p.hawb}`;
    case PO_ACTIVITY_ACTION.PACKING_LIST_ADDED:
      return `Added packing list v${p.version}`;
    case PO_ACTIVITY_ACTION.DELIVERY_REQUESTED:
      return `Requested delivery: ship by ${fmtDay(p.shipBy)}`;
    case PO_ACTIVITY_ACTION.DELIVERY_REQUEST_WITHDRAWN:
      return 'Withdrew the delivery request';
    case PO_ACTIVITY_ACTION.DELIVERY_REQUEST_ANSWERED:
      return `Answered the delivery request: ${p.shipments.map((s) => fmtDay(s.plannedDate)).join(DATE_SEPARATOR)}`;
    default:
      return null;
  }
}
